import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AmIconModule } from '../am-icon/am-icon.module';
import { ThreadComponent } from './thread/thread.component';
export * from './thread/thread.types';

@NgModule({
  declarations: [ThreadComponent],
  imports: [CommonModule, MatButtonModule, AmIconModule],
  exports: [ThreadComponent],
})
export class CommentsModule {}
